/* eslint-disable aveny/no-color-rule */

import Box from '@mui/material/Box';
import EDTypography from '../Typography/EDTypography';
import { IRapportAssociationControl } from './RapportMallTypes';
import { getPositionStyle } from './RapportMallUtils';
import TextField from '@mui/material/TextField';
import { RapportKontrollEditPosition } from './RapportKontrollEditPosition';
import { RapportKontrollHeader } from './RapportKontrollHeader';

export interface IProps {
  ctrl: IRapportAssociationControl;
  sx?: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onSelect?: (path: number[]) => void;
  onUpdate?: (updatedControl: IRapportAssociationControl) => void;
  controlPath: number[];
  selected?: boolean;
  maxWidth: number;
}

export const RapportAssociation: React.FC<IProps> = props => {
  const { ctrl, sx, onMouseEnter, onMouseLeave, selected, maxWidth } = props;
  const handleSelect = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    if (props.onSelect) {
      props.onSelect(props.controlPath);
    }
  };
  return (
    <Box
      sx={{
        background: '#ffccbc',
        border: selected ? '2px solid #1976d2' : '1px solid #aaa',
        boxSizing: 'border-box',
        ...getPositionStyle(ctrl, props.controlPath.length > 1, maxWidth),
        ...sx,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleSelect}
      data-control-path={props.controlPath.join('-')}
    >
      <EDTypography variant="body2">
        Association: {ctrl.Association}
      </EDTypography>
      <EDTypography variant="caption" color="textSecondary">
        Association
      </EDTypography>
    </Box>
  );
};

export interface IRapportAssociationEditProps {
  value: IRapportAssociationControl;
  onChange: (ctrl: IRapportAssociationControl) => void;
}

export const RapportAssociationEdit: React.FC<
  IRapportAssociationEditProps
> = props => (
  <Box sx={{ mt: 2 }}>
    <RapportKontrollHeader value={props.value} />
    <TextField
      label="Association"
      value={props.value.Association ?? ''}
      onChange={e =>
        props.onChange({ ...props.value, Association: e.target.value })
      }
      fullWidth
      size="small"
      sx={{ mb: 2 }}
    />
    <RapportKontrollEditPosition
      value={props.value}
      onChange={props.onChange}
    />
  </Box>
);
